<template>
  <div class="classic-editor" v-if="classic">
    <ckeditor :editor="editor" v-model="val" :config="editorConfig" @input="handleInput"></ckeditor>
  </div>
  <div class="document-editor" v-else>
    <div class="document-editor__toolbar" id="document-editor-toolbar"></div>
    <div class="document-editor__editable-container">
      <div class="document-editor__editable">
        <ckeditor
                :editor="editor"
                v-model="val"
                :config="editorConfig"
                @ready="onReady"
                @input="handleInput"
        ></ckeditor>
      </div>
    </div>
  </div>
</template>

<script>
import CKEditor from '@ckeditor/ckeditor5-vue';
import {Message} from 'element-ui';

class OxUploaderAdapter {
    constructor(loader, vm) {
        this.loader = loader;
        this.vm = vm;
        this.File = new window.BaaS.File();
    }

    send(file) {
        return new Promise((resolve, reject) => {
            this.File.upload(
                {fileObj: file},
                {categoryID: this.vm.categoryId}
            ).then(
                res => {
                    resolve(res);
                },
                err => {
                    Message.error(
                        '上传失败，请检查网络并稍后再试，若问题仍然存在请联系开发人员'
                    );
                    reject(err);
                }
            );
        });
    }

    upload() {
        return this.loader.file.then(
            file =>
                new Promise((resolve, reject) => {
                    this.send(file).then(res => {
                        resolve({default: res.data.path});
                    }).catch(err => reject(err));
                })
        );
    }

    abort() {
        Message.warning('已中止上传');
    }
}

export default {
    props: {
        value: String,
        categoryId: String,
        classic: {
            classic: Boolean,
            default: true
        }
    },
    components: {
        ckeditor: CKEditor.component
    },
    data() {
        let vm = this;
        let uploadPlugin = () => {
            return function (editor) {
                editor.plugins.get(
                    'FileRepository'
                ).createUploadAdapter = loader => {
                    return new OxUploaderAdapter(loader, vm);
                };
            };
        };
        return {
            val: '',
            editorConfig: {
                extraPlugins: [uploadPlugin()],
                toolbar: [
                    'undo',
                    'redo',
                    '|',
                    'heading',
                    '|',
                    'highlight',
                    'textcolor',
                    'fontsize',
                    'bold',
                    'italic',
                    'Strikethrough',
                    'Underline',
                    '|',
                    'alignment',
                    'bulletedList',
                    'numberedList',
                    'blockQuote',
                    '|',
                    'link',
                    'imageUpload'
                ]
            }
        };
    },
    watch: {
        value: function(newVal){
          this.val = newVal||'';
        }
    },
    computed: {
        editor() {
            if (this.classic) {
                return require('ckeditor5-build-full-plugins');
            } else {
                return require('@ckeditor/ckeditor5-build-decoupled-document');
            }
        }
    },
    mounted(){
      setTimeout(()=>{
        this.$set(this, 'val', this.value||''); //hotfix: 修复第一次无法加载内容的问题
      }, 500);
    },
    methods: {
        onReady(editor) {
            document
                .querySelector('#document-editor-toolbar')
                .appendChild(editor.ui.view.toolbar.element);
        },
        handleInput() {
            this.$emit('input', this.val);
        }
    }
};
</script>

<style>
.ck-content {
  min-height: 400px;
  line-height: 180% !important;
}

.document-editor {
  border: 1px solid #ddd;
  max-height: 600px;
  display: flex;
  flex-flow: column nowrap;
  margin: 15px;
}

.document-editor__toolbar {
  /* Make sure the toolbar container is always above the editable. */
  z-index: 1;

  /* Create the illusion of the toolbar floating over the editable. */
  box-shadow: 0 0 5px hsla(0, 0%, 0%, 0.2);

  /* Use the CKEditor CSS variables to keep the UI consistent. */
  border-bottom: 1px solid var(--ck-color-toolbar-border);
}

/* Adjust the look of the toolbar inside the container. */
.document-editor__toolbar .ck-toolbar {
  border: 0;
  border-radius: 0;
}

/* Make the editable container look like the inside of a native word processor application. */
.document-editor__editable-container {
  padding: calc(2 * var(--ck-spacing-large));
  background: var(--ck-color-base-foreground);

  /* Make it possible to scroll the "page" of the edited content. */
  overflow-y: scroll;
}

.document-editor__editable > .ck-editor__editable {
  /* Set the dimensions of the "page". */
  width: 15.8cm;
  min-height: 800px;
  /* Keep the "page" off the boundaries of the container. */
}

.document-editor__editable > .ck-content {
  padding: 1cm 2cm 2cm !important;
  border: 1px hsl(0, 0%, 82.7%) solid !important;
  background: white;
  /* The "page" should cast a slight shadow (3D illusion). */
  box-shadow: 0 0 5px hsla(0, 0%, 0%, 0.1) !important;
  /* Center the "page". */
  margin: 0 auto !important;
}

/* Adjust the headings dropdown to host some larger heading styles. */
.document-editor .ck-heading-dropdown .ck-list .ck-button__label {
  line-height: calc(
          1.5 * var(--ck-line-height-base) * var(--ck-font-size-base)
  );
  min-width: 6em;
}

/* Scale down all heading previews because they are way too big to be presented in the UI.
Preserve the relative scale, though. */
.document-editor
.ck-heading-dropdown
.ck-list
.ck-button:not(.ck-heading_paragraph)
.ck-button__label {
  transform: scale(0.8);
  transform-origin: left;
}

/* Set the styles for "Heading 1". */
.document-editor .ck-content h2,
.document-editor .ck-heading-dropdown .ck-heading_heading1 .ck-button__label {
  font-size: 2.18em;
  font-weight: normal;
}

.document-editor .ck-content h2 {
  line-height: 1.37em;
  padding-top: 0.342em;
  margin-bottom: 0.142em;
}

/* Set the styles for "Heading 2". */
.document-editor .ck-content h3,
.document-editor .ck-heading-dropdown .ck-heading_heading2 .ck-button__label {
  font-size: 1.75em;
  font-weight: normal;
  color: hsl(203, 100%, 50%);
}

.document-editor
.ck-heading-dropdown
.ck-heading_heading2.ck-on
.ck-button__label {
  color: var(--ck-color-list-button-on-text);
}

/* Set the styles for "Heading 2". */
.document-editor .ck-content h3 {
  line-height: 1.86em;
  padding-top: 0.171em;
  margin-bottom: 0.357em;
}

/* Set the styles for "Heading 3". */
.document-editor .ck-content h4,
.document-editor .ck-heading-dropdown .ck-heading_heading3 .ck-button__label {
  font-size: 1.31em;
  font-weight: bold;
}

.document-editor .ck-content h4 {
  line-height: 1.24em;
  padding-top: 0.286em;
  margin-bottom: 0.952em;
}

/* Set the styles for "Paragraph". */
.document-editor .ck-content p {
  font-size: 1em;
  line-height: 1.1em !important;
  padding-top: 0.5em;
  margin-bottom: 1.13em;
}

.document-editor .ck-content blockquote {
  font-family: Georgia, serif;
  margin-left: calc(2 * var(--ck-spacing-large));
  margin-right: calc(2 * var(--ck-spacing-large));
}
</style>
